module.exports = __webpack_public_path__ + "img/new-item.04a496e4.svg";